// extracted by mini-css-extract-plugin
export var animationContainer = "_j8-0";
export var asteriskIcon = "_j8-8";
export var conversationLeftSection = "_j8-4";
export var conversationListItem = "_j8-3";
export var conversationMiddleSection = "_j8-5";
export var conversationRightSection = "_j8-6";
export var detailsContent = "_j8-1";
export var listContainer = "_j8-7";
export var modalContent = "_j8-2";